<template>
  <div>
    <div v-if="!isMobile" class="ceMetaLayout">
      <div class="headerWrapper">
        <div class="header">
          <div>
            <img
              src="../../assets/statics/logo.png"
              style="width: 100px; height: auto"
            />
          </div>
          <div class="links">
            <a href="/industryChat">AI小红书文案助手</a>
          </div>
          <div class="user">
            <div class="wordsCount">
              <div class="count">可用字数：{{ count }} 字</div>
              <div class="change" @click="click">兑换更多字数</div>
            </div>
            <span v-if="!!userName" class="el-dropdown-link">
              {{ userName }}
            </span>
            <!-- <el-dropdown v-if="!!userName" @command="accountOperate">
                    <span class="el-dropdown-link">
                      {{userName}}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="logout">登出</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown> -->
          </div>
        </div>
      </div>
      <div>
        <router-view />
      </div>
    </div>
    <div v-else class="mobileLayout">
      <div class="headerWrapper">
        <div class="mobileTitle">CeMeta 小红书营销文案助手</div>
        <div v-if="!!userName" class="mobileUserLayout">
          <el-button
            style="
              border-radius: 1rem;
              height: 2rem;
              background: linear-gradient(150deg, #7ba0ff, #ee74ff);
              color: #ffffff;
              padding: 4px 8px;
            "
            @click="click"
          >
            兑换字数
          </el-button>
          <el-dropdown
            @command="handleCommand"
            trigger="click"
            class="dropdown"
          >
            <span class="el-dropdown-link">
              <i class="el-icon-user"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item disabled>
                <div class="mobileCount">
                  <span>剩余字数</span>
                  <span>{{ count }}</span>
                </div>
              </el-dropdown-item>
              <el-dropdown-item command="loginOut" class="loginOut">
                退出
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div>
        <router-view />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isMobile: false,
    };
  },
  computed: {
    userName() {
      // {
      //     id: '',
      //     name: '',
      //     role: 0,
      //     token: ''
      // }
      return this.$store.state.user.name;
    },
    count() {
      return this.$store.state.count;
    },
  },
  methods: {
    accountOperate() {},
    click() {
      this.$store.dispatch("setChangeOpen", true);
    },
    handleCommand(type) {
      if (type == "loginOut") {
        localStorage.removeItem("token");
        localStorage.removeItem("userId");
        localStorage.removeItem("name");
        localStorage.removeItem("phone");
        localStorage.removeItem("role");

        window.location.href = "/login";
      }
    },
  },
  created() {
    console.log(window, "999");
    this.isMobile = window.navigator.userAgent.includes("Mobile");
  },
};
</script>
<style lang="less" scoped>
.ceMetaLayoutWrapper {
  overflow-y: auto;

  .headerWrapper {
    width: 100%;
    border-bottom: 1px solid #e1e2e5;
  }
}
.ceMetaLayout {
  width: 100%;
  min-width: 1280px;
  margin: 0 auto;
  min-height: 100vh;
  // overflow-y: auto;
  background-image: url("../../assets/statics/images/finalbackground.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  &.fixedWidth {
    width: 1280px;
  }
}

.header {
  margin: 0 auto;
  width: 1280px;
  height: 73px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .links {
    a {
      color: #333333;
      font-size: 20px;

      &:hover {
        opacity: 0.8;
      }
    }

    a + a {
      margin-left: 63px;
    }
  }

  .user {
    align-items: center;
    display: flex;
    // visibility: hidden;

    &.show {
      visibility: visible;
    }

    .nickname {
      display: inline-block;
      cursor: pointer;
    }

    .down {
      margin-left: 6px;
      margin-right: 12px;
    }
    .avatar {
      border: 1px solid #333 !important;
      border-radius: 50%;
    }
  }
}

.body {
  min-width: 1280px;
}

.userMenu {
  display: flex;
  flex-direction: column;

  .link {
    padding: 12px 24px;
    display: flex;
    align-items: center;
    font-size: 16px;

    :global {
      .mtbird-icon {
        font-size: 20px;
        margin-right: 8px;
      }
    }
  }

  .active {
    background-color: #f9f9f9;
  }
}

.ceMetaIndexLayout {
  background-color: #e1e2e5 !important;
}

.userMenuPopover {
  :global {
    .ant-popover-inner {
      padding: 0;
    }
  }
}

// ------------------------ UserLayout

.rightContent {
  flex: 1;
  padding: 28px;
  background: #eeeff1;
  box-shadow: 7px 11px 18px 0px rgba(220, 220, 220, 0.04);
  border-radius: 8px;
  margin-left: 35px;
}

.userLayoutWrapper {
  background-color: #e6e7e9;
}

.userLayout {
  width: 1280px;
  margin: 0 auto;

  .content {
    display: flex;
    width: 100%;
  }
}

.leftMenu {
  width: 208px;
  height: 295px;
  box-sizing: border-box;
  padding: 0 12px;
  border: 1px solid #ffffff;
  border-radius: 4px;
  background-color: #f3f4f6;
  border-radius: 6px;

  > div {
    height: 82px;
    display: flex;
    align-items: center;

    padding-left: 24px;
    font-size: 20px;

    .icon {
      font-size: 24px;
      padding: 8px;
      display: inline-block;
      margin-right: 12px;
    }
  }
}

.menuItem + .menuItem {
  border-top: 1px solid #e0e0e0;
}

.menuItem {
  color: #999999;
  &.active {
    color: #333333;

    .icon {
      width: 40px;
      height: 40px;
      background: #333333;
      border-radius: 50%;
      color: #fff;
    }
  }
}

.wordsCount {
  display: flex;
  align-items: center;
  margin-right: 36px;

  .count {
    margin-right: 24px;
  }
  .change {
    display: flex;
    align-items: center;
    font-weight: 500;
    color: #526aee;
    cursor: pointer;
  }
}

.mobileLayout {
  .headerWrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 20px;
    box-shadow: 0 2px 20px 1px rgba(0, 0, 0, 4%);

    .mobileUserLayout {
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }
}
.dropdown {
  padding: 0;
}
.mobileCount {
  display: flex;
  flex-direction: column;
  align-items: center;

  :first-child {
    margin-top: 8px;
  }
  :last-child {
    margin-bottom: 8px;
  }
  span {
    line-height: 1.5em;
  }
}
.el-dropdown-link {
  .el-icon-user {
    font-weight: bold;
  }
}
.loginOut {
  text-align: center;
  border-top: rgb(229, 231, 235) solid 1px;
}

// to fix 在ios设备中，el-select组件下拉框，点击2次才能选中问题。
/deep/ .el-scrollbar {
  .el-scrollbar__bar {
    opacity: 1 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/index.vue